module.exports = __webpack_public_path__ + "img/404.b68e31f1.jpg";